import React from "react";
import ListEditor from "../ListEditor";
import { adminApi } from "../../lib/api";
import { Label, TextInput, NumberInput, Switch, ImageUploader } from "../FormControls";

const newCert = () => ({
  name: "",
  issuer: "",
  year: "",
  credential_url: "",
  image_url: "",
  visible: true,
  order: 0,
});

const Certifications = () => (
  <ListEditor
    resource={adminApi.certifications}
    resourceKey="certifications"
    title="Certifications"
    newItem={newCert}
    searchFields={["name", "issuer"]}
    renderRow={(c) => (
      <div className="min-w-0">
        <div className="text-white font-medium truncate">{c.name}</div>
        <div className="text-xs text-slate-500 truncate">{c.issuer} · {c.year}</div>
      </div>
    )}
    renderForm={(d, set) => (
      <>
        <div>
          <Label>Certificate name</Label>
          <TextInput value={d.name} onChange={(v) => set("name", v)} />
        </div>
        <div className="grid sm:grid-cols-2 gap-3">
          <div>
            <Label>Issuer</Label>
            <TextInput value={d.issuer} onChange={(v) => set("issuer", v)} />
          </div>
          <div>
            <Label>Year</Label>
            <TextInput value={d.year} onChange={(v) => set("year", v)} />
          </div>
        </div>
        <div>
          <Label>Credential URL</Label>
          <TextInput value={d.credential_url} onChange={(v) => set("credential_url", v)} placeholder="https://..." />
        </div>
        <div>
          <Label>Certificate image</Label>
          <ImageUploader value={d.image_url} onChange={(v) => set("image_url", v)} />
        </div>
        <div className="flex items-center gap-6">
          <Switch value={d.visible} onChange={(v) => set("visible", v)} label="Visible" />
          <div className="flex items-center gap-2 ml-auto">
            <Label>Order</Label>
            <NumberInput value={d.order} onChange={(v) => set("order", v)} />
          </div>
        </div>
      </>
    )}
  />
);

export default Certifications;
